import { FunctionComponent, memo } from 'react';
import { StoryCardArticleContent } from '../../../../services';
import { HorizontalStoryFeedCardProps, HorizontalStoryFeedContentCommon } from '../../../../shared';
import { HorizontalStoryFeedCardWrapper } from '../HorizontalStoryFeedCardWrapper';

export const HorizontalStoryFeedArticle: FunctionComponent<HorizontalStoryFeedCardProps> = memo(
  ({ card }) => {
    const { type, content, isPinnedToTopOfNewsFeed, isPinnedToTopOfStory } = card;
    const { title, sourceName, abstract } = content as StoryCardArticleContent;

    return (
      <HorizontalStoryFeedCardWrapper card={card}>
        <HorizontalStoryFeedContentCommon
          isPinnedToTopOfNewsFeed={isPinnedToTopOfNewsFeed}
          isPinnedToTopOfStory={isPinnedToTopOfStory}
          cardType={type}
          source={sourceName}
          title={title}
          text={abstract}
        ></HorizontalStoryFeedContentCommon>
      </HorizontalStoryFeedCardWrapper>
    );
  }
);
